import store from '@/store'
import { $oculis } from '@axios'
import { transformRequestOptions } from '@core/utils'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        fetchDecipherProjects(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/search-decipher/`, {
                    params:queryParams,
                    paramsSerializer: params => transformRequestOptions(params),
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        addProject(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .post(`/projects/`, payload)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        updateProject(ctx, payload) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .patch(`/projects/${payload.id}/`, payload)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        updateMedia(ctx, payload) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .patch(`/medias/${payload.id}/`, payload)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        fetchOculisProject(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${queryParams.project}/`, {
                    params:queryParams,
                    paramsSerializer: params => transformRequestOptions(params),
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },


        fetchOculisProjects(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/`, {
                    params:queryParams,
                    paramsSerializer: params => transformRequestOptions(params),
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        bulkCreateAOIs(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .post(`/projects/${payload.project}/medias/${payload.media}/aois/bulk_create/`, payload)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        addAOI(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .post(`/projects/${payload.project}/medias/${payload.media}/aois/`, payload)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        updateAOI(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .patch(`/projects/${payload.project}/medias/${payload.media}/aois/${payload.id}/`, payload)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        deleteAOI(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .delete(`/projects/${payload.project}/medias/${payload.media}/aois/${payload.id}/`)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },


        addNet(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .post(`/projects/${payload.project}/medias/${payload.media}/nets/`, payload)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        updateNet(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .patch(`/projects/${payload.project}/medias/${payload.media}/nets/${payload.id}/`, payload)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        deleteNet(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .delete(`/projects/${payload.project}/medias/${payload.media}/nets/${payload.id}/`)
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        

        fetchAOIElements(ctx, project, queryParams={}) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/elements/`, {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },


        fetchMediasAOIs(ctx, project, queryParams={}) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${project}/medias/`, {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },


        fetchMedia(ctx, payload) {
            // store.commit('app/LOADING', true)
            const { id, ...queryParams } = payload;
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/medias/${id}/`, {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        
        // fetchMediaHeatmap(ctx, payload, queryParams) {
        fetchMediaHeatmap(ctx, payload) {
            // store.commit('app/LOADING', true)
            const { project, media, ...queryParams } = payload;
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${project}/medias/${media}/heatmap/`, {
                    params: queryParams,
                    // params: filters,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },

        // fetchMediaAnalysis(ctx, payload, queryParams) {
        fetchMediaAnalysis(ctx, payload) {
            // store.commit('app/LOADING', true)
            const { project, media, ...queryParams } = payload;
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${project}/medias/${media}/analysis/`, {
                    params: queryParams,
                    // params: filters,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        
        fetchMediaComparisonAnalysis(ctx, payload) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${payload.project}/medias/compare_analysis/`, {
                    params: payload.queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        fetchScanpath(ctx, payload) {
            // store.commit('app/LOADING', true)
            const { project, media, ...queryParams } = payload;
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${project}/medias/${media}/scanpath/`, {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        addMedia(ctx, payload) {
            const formImageData = new FormData()
            formImageData.append('media', payload.file)
            formImageData.append(`name`, payload.name);
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .post(`/projects/${payload.id}/medias/`,
                    formImageData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        addFixations(ctx, payload) {
            const formImageData = new FormData()
            formImageData.append('file', payload.file)
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .post(`/medias/${payload.id}/bulk_create_fixations/`,
                    formImageData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        deleteFixations(ctx, id) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .delete(`/medias/${id}/clear_data/`)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        deleteMedia(ctx, id) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .delete(`/medias/${id}/`)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        downloadKPIAnalysis(ctx, payload ) {
            store.commit('app/LOADING', true)
            const { project, ...queryParams } = payload;
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${project.id}/export-analysis/`, { responseType:'blob',
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },

        fetchProjectCrosstabs(ctx, projectId) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${projectId}/crosstabs/`)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        
        fetchSavedFilters(ctx, projectId) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .get(`/projects/${projectId}/saved-filters/`)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        
        saveFilter(ctx, { projectId, payload }) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .post(`/projects/${projectId}/saved-filters/`, payload)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },

        deleteFilter(ctx, { projectId, filterId }) { 
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .delete(`/projects/${projectId}/saved-filters/${filterId}/`)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        updateFilter(ctx, { projectId, filterId, payload }) { //filterId? 
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $oculis()
                .patch(`/projects/${projectId}/saved-filters/${filterId}/`, payload)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        fetchSecureMediaBlob(ctx, mediaUrl) {
            return new Promise((resolve, reject) => {
                $oculis()
                .get(mediaUrl, { responseType:'blob', })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        }
    
    }
}